import { ButtonGroup, Td } from "@chakra-ui/react";
import { Container, Dev, Form, Heading, IconButton, Row, Searchable, Table, Tag } from "components";
import { Mask } from "config";
import { Moment } from "config";
import { Enums } from "config";
import { useFiscalNotes } from "hooks";
import { useState } from "react";

// Screens
import { Fiscal as FiscalScreens } from "screens"

export default function Fiscal(){

    const [ term, setTerm ] = useState()
    const [ status, setStatus ] = useState()
    const [ page, setPage ] = useState(1)
    const [ note, setNote ] = useState()
    
    const fiscal = useFiscalNotes(page, term, status)    
    
    const columns = [{ children: 'Número', isNumeric: true }, { children: 'Código' }, { children: 'Pedido' }, { children: 'Cliente' }, { children: 'Valor', isNumeric: true }, { children: 'Status' }, { children: 'Data', isNumeric: true }]

    return(
    <>
    <Container maxW="90%" mt={10}>

        <Heading title="Fiscal">
            <ButtonGroup size="xs" isDisabled={fiscal.isFetching}>
                <IconButton icon="refresh" isLoading={fiscal.isFetching} onClick={fiscal.refetch} />
                <Dev data={fiscal.data} />
            </ButtonGroup>
        </Heading>

        <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por ID, Código ou número da nota..">
            <Form.Select onChange={e => setStatus(e.target.value)} options={[{ label: 'Todos os status', value: '' }, { label: 'Solicitações', value: Enums.FiscalNoteStatus.WAITING },{ label: 'Canceladas', value: Enums.FiscalNoteStatus.CANCELED }, { label: 'Em processamento', value: Enums.FiscalNoteStatus.PROCESSING }, { label: 'Emitida', value: Enums.FiscalNoteStatus.GENERATED }]} />
        </Searchable>
    
        <Table columns={columns} mt={4} setPage={setPage} meta={fiscal.data?.meta}>
            { fiscal.data?.data?.map(item => <Item key={item.id} data={item} onClick={() => setNote(item)} />) }
        </Table>
    
        <FiscalScreens.View isOpen={!!note} data={note} onClose={() => setNote(null)} />

    </Container>
    </>
    )
}

const Item = ({ data, ...props }) => {
    const status = Enums.FiscalNoteStatus.data(data?.status)

    return(
    <Row {...props}>
        <Td isNumeric>{data?.number ?? <>&mdash;</>}</Td>
        <Td>{data?.cod}</Td>
        <Td>{data?.order?.cod}</Td>
        <Td>{data?.distributor?.name ?? data?.consultant?.customer?.name}</Td>
        <Td isNumeric>{`R$ ${Mask.price(data?.amount ?? 0)}`}</Td>
        <Td><Tag colorScheme={status.colorScheme} children={status.label} /></Td>
        <Td isNumeric>{Moment(data?.created_at).fromNow()}</Td>
    </Row>
    )
}